module["exports"] = [
  "Apto. ###",
  "Sobrado ##",
  "Casa #",
  "Lote ##",
  "Quadra ##"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/pt_BR/address/secondary_address.js
// module id = 3384
// module chunks = 1609